import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { getJwt, hasAuthenticatedUser } from "@/app/AuthService.ts";
import { isDevelopment } from "@/shared/helper";

export const createAxiosClient = async () => {
  const jwt = await getJwt();
  const tokenValidationRequired = await hasAuthenticatedUser();
  const uuid = uuidv4();

  // In development mode, we can either login with a test user or an authenticated staging user.
  // If we use a test user, we need to send requests to the mock API. For an authenticated user we want to use the "real" API based on the environment.
  const baseURL =
    isDevelopment && !tokenValidationRequired
      ? "https://eu1.anypoint.mulesoft.com/mocking/api/v1/links/c047274d-1e5d-4d30-9731-ff63dca72e38"
      : `${import.meta.env.VITE_MULESOFT_API_BASE_URL}/hub-api/v1/api`;

  return axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${jwt}`,
      "X-CORRELATION-ID": uuid,
    },
  });
};

export const createGuestApiAxiosClient = async () => {
  const uuid = uuidv4();

  const baseURL = isDevelopment
    ? "https://eu1.anypoint.mulesoft.com/mocking/api/v1/sources/exchange/assets/c43ff940-84ac-4e5f-9f9f-5bd4e2d849f7/wag-exp-hub-guest-api/1.0.3/m"
    : `${import.meta.env.VITE_MULESOFT_API_BASE_URL}/hub-guest-api/v1/api`;

  return axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CORRELATION-ID": uuid,
    },
  });
};
